"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.ovszSignedMessages = exports.OvszSigned = void 0;
const schema_1 = require("../../../schema");
var OvszSigned;
(function (OvszSigned) {
    OvszSigned["OVSZ_SIGNED"] = "OVSZ_SIGNED";
})(OvszSigned || (exports.OvszSigned = OvszSigned = {}));
exports.ovszSignedMessages = {
    [OvszSigned.OVSZ_SIGNED]: {
        id: "ktx.basicRegistrationData.patientStatementOfConsentOvsz.ovszSigned.OVSZ_SIGNED",
        defaultMessage: "Az OVSZ hozzájáruló nyilatkozatot a beteg aláírásával elfogadta"
    }
};
const ovszSigned = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(OvszSigned.OVSZ_SIGNED)
]).interpretation({ vocab: "ktx", code: "signed_statement_of_consent_ovsz" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ ovszSigned });
